import { useTranslation } from 'react-i18next';

import { PageHeader } from '../../../shared/ui/PageHeader';
import { Spinner } from '../../../shared/ui/Spinner';
import { useAdminUsers } from '../hooks/useAdminUsers';
import { UsersTable } from '../components/UsersTable';

// PARA-106, AC-2/AC-3.
export function UsersPage(): JSX.Element {
  const { t } = useTranslation();
  const { data, isLoading } = useAdminUsers();

  return (
    <section>
      <PageHeader title={t('users.title')} />
      {isLoading || !data ? <Spinner /> : <UsersTable users={data} />}
    </section>
  );
}
